import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var BezierCurve03 = function BezierCurve03(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M10.8571 7 5.1429 17M6 19h11.9998m.8573-2L13.1429 7M3.6 21h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C6 20.2401 6 19.9601 6 19.4v-.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C5.24 17 4.96 17 4.4 17h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 17.7599 2 18.0399 2 18.6v.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C2.76 21 3.04 21 3.6 21m16 0h.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C22 20.2401 22 19.9601 22 19.4v-.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C21.2401 17 20.9601 17 20.4 17h-.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C18 17.7599 18 18.0399 18 18.6v.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.2139.109.4939.109 1.054.109m-8-14h.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C14 6.24 14 5.96 14 5.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C13.2401 3 12.9601 3 12.4 3h-.8c-.5601 0-.8401 0-1.054.109a1 1 0 0 0-.437.437C10 3.76 10 4.04 10 4.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C10.7599 7 11.0399 7 11.6 7"
    })
  }));
};
export default BezierCurve03;